import AmexPlatinumNightsCardRefresh from './AmexPlatinumNightsCardRefresh';

export default AmexPlatinumNightsCardRefresh;
